import { useEffect, useState } from 'react';

/**
 * Cuánto del layout viewport tapa el teclado virtual (u otro recorte del
 * visual viewport). En desktop queda en 0. Sirve para subir overlays `fixed`
 * sin cambiar el layout de `sm+`.
 */
export function useVisualViewportBottomInset(): number {
  const [inset, setInset] = useState(0);

  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) {
      return undefined;
    }

    const sync = () => {
      const covered = window.innerHeight - viewport.height - viewport.offsetTop;
      setInset(Math.max(0, Math.round(covered)));
    };

    sync();
    viewport.addEventListener('resize', sync);
    viewport.addEventListener('scroll', sync);
    return () => {
      viewport.removeEventListener('resize', sync);
      viewport.removeEventListener('scroll', sync);
    };
  }, []);

  return inset;
}
